import { takeEvery, put, call } from "redux-saga/effects";
import { FETCH_LEAVES, CREATE_LEAVE, UPDATE_LEAVE, DELETE_LEAVE } from "./actionTypes";
import { fetchLeavesSuccess, fetchLeavesFailure, createLeaveSuccess, createLeaveFailure, updateLeaveSuccess, updateLeaveFailure, deleteLeaveSuccess, deleteLeaveFailure, fetchLeaves } from "./actions";
import { post, update, del } from "../../../helpers/api_helper";
import { showToast, showConfirm } from "../../../common/Toaster";
import Swal from "sweetalert2";
function* fetchLeavesSaga(action) {
  try {
    const apiUrl = process.env.REACT_APP_GET_LEAVE_API;
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(post, apiUrl, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve leave!");
    }
    yield put(fetchLeavesSuccess(response));
  } catch (error) {
    yield put(fetchLeavesFailure(error.message));
  }
}

function* createLeaveSaga({ payload }) {
  debugger
  try {
    const { formData, isEdit } = payload;
    const apiUrl = process.env.REACT_APP_SAVE_LEAVE_API;
    console.log(apiUrl)
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      showToast({ icon: response?.status, title: response?.status, text: response.message });
      yield put(createLeaveSuccess(response));
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchLeaves(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      showToast({ icon: "error", title: "Error", text: response.message });
      yield put(createLeaveFailure(response));
    }
  } catch (error) {
    showToast({ icon: "error", title: "API Error", text: error.message || "An error occurred while saving the leave" });
    yield put(createLeaveFailure(error.message));
  }
}

function* updateLeaveSaga({ payload }) {
  try {
    const response = yield call(update, `${process.env.REACT_APP_UPDATE_LEAVE_API}/${payload.id}`, payload);
    yield put(updateLeaveSuccess(response));
  } catch (error) {
    yield put(updateLeaveFailure(error.message));
  }
}

function* deleteLeaveSaga({ payload }) {
  try {
    yield call(del, `${process.env.REACT_APP_DELETE_LEAVE_API}/${payload}`);
    yield put(deleteLeaveSuccess(payload));
  } catch (error) {
    yield put(deleteLeaveFailure(error.message));
  }
}

function* leaveSaga() {
  yield takeEvery(FETCH_LEAVES, fetchLeavesSaga);
  yield takeEvery(CREATE_LEAVE, createLeaveSaga);
  yield takeEvery(UPDATE_LEAVE, updateLeaveSaga);
  yield takeEvery(DELETE_LEAVE, deleteLeaveSaga);
}

export default leaveSaga;